import { Injectable } from "@angular/core";
import { QObject } from "@app/models";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SalesMeetingService {
  selectedIntakeObject$ = new BehaviorSubject<QObject>(null);
  hasLead$ = new BehaviorSubject<boolean>(false);
}
